// Rules:
//   · http.* returns data (not the axios response object) — no .data, no .json()
//   · 204 No Content → returns null
//   · All errors surface as ApiError (thrown by axiosClient interceptor)
//   · upload: never set Content-Type manually — axios sets multipart/form-data + boundary
//   · download: returns a Blob

import axiosClient from './axiosClient';

const unwrap = res => (res.status === 204 ? null : res.data);

export const http = {
  get: (url, config) => axiosClient.get(url, config).then(unwrap),
  post: (url, data, config) => axiosClient.post(url, data, config).then(unwrap),
  put: (url, data, config) => axiosClient.put(url, data, config).then(unwrap),
  patch: (url, data, config) => axiosClient.patch(url, data, config).then(unwrap),
  delete: (url, config) => axiosClient.delete(url, config).then(unwrap),
  // Setting Content-Type: undefined removes the instance default so the browser
  // can append the correct multipart boundary automatically.
  upload: (url, form, config = {}) =>
    axiosClient
      .post(url, form, { ...config, headers: { ...config.headers, 'Content-Type': undefined } })
      .then(unwrap),
  download: (url, config = {}) =>
    axiosClient.get(url, { ...config, responseType: 'blob' }).then(r => r.data),
  downloadResponse: (url, config = {}) =>
    axiosClient.get(url, { ...config, responseType: 'blob' }),
};
